import { createAsyncThunk } from "@reduxjs/toolkit";

import { conditionRuleset } from "./helpers/conditionRuleset";

import { requestStorage } from "../apiRequests/requestStorage";

export const requestEmailUterum = createAsyncThunk(
  "thunks/requestEmailUterum",
  async (data = { email: "", newsletter: false }, thunkAPI) => {
    const state = thunkAPI.getState();
    const { Uterum, requests } = state;
    const { apiConfigs } = requests;

    (!data || Object.keys(data).length === 0) &&
      console.error(`Unexpected data in thunks/requestEmailUterum: ${data}`);

    Object.keys(data).some(
      (key) =>
        key !== "email" &&
        key !== "newsletter" &&
        console.error(`Unexpected key in thunks/requestEmailUterum: ${key}`)
    );

    const response = await requestStorage({
      method: "post",
      apiConfigs,
      data: {
        uterum: Uterum,
        ...data,
      },
      onSuccess: () => ({ data: null }),
    });

    return response.data;
  },
  conditionRuleset
);
